import "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/core-js/modules/es.array.iterator.js";
import "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/core-js/modules/es.promise.js";
import "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/core-js/modules/es.object.assign.js";
import "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/core-js/modules/es.promise.finally.js";
import 'intersection-observer';
import createPage from '@/create-page';
import Share from '@/views/freebuy/share.vue';
createPage({
  component: Share,
  checkForbidden: false,
  // 本页面印尼不支持英语
  defaultLangCover: {
    'idn': ['id-id']
  }
});